<template>
	<div v-editable="blok" class="w-full grid gap-4 grid-cols-1">
		<div class="flex justify-between items-start">
			<div>
				<p
					class="text-[55px] font-heldane leading-none"
					:class="blok.title_align || ''"
				>
					{{ blok.title }}
				</p>
				<p class="text-sm" :class="blok.title_align || ''">
					{{ blok.text }}
				</p>
			</div>

			<div v-if="blok.call_to_action?.length > 0" class="grid justify-center">
				<StoryblokComponent
					v-for="call_to_action in blok.call_to_action"
					:key="call_to_action._uid"
					:blok="call_to_action"
					class="!p-2"
				/>
			</div>
		</div>

		<template v-if="blok.is_carousel">
			<Carousel
				:slides="items"
				:blok="blok"
				:type-of-slide="ItemType.CATEGORY"
			/>
		</template>
		<template v-else>
			<div class="grid lg:grid-cols-4 grid-cols-2">
				<div v-for="item in items" :key="item._uid">
					<CategoryHero :blok="item" :lazy-load="blok.lazy_load_images" />
				</div>
			</div>
		</template>
	</div>
</template>

<script setup lang="ts">
import type {
	StaticCategoriesBlok,
	CategoryHeroBlok
} from "~/types/storyblok/storyblok";
import type { CategoryWithFiles } from "@nwt/norce-pwa/dist/runtime/types/api/category/category";

type Item = CategoryHeroBlok | CategoryWithFiles;

interface Props {
	blok: StaticCategoriesBlok;
}
const { blok } = defineProps<Props>();

const { createCategoryLink } = useCategory();
const localePath = useLocalePath();
const items = ref<Item[]>([]);

const toCategoryHeroBlok = (item): CategoryHeroBlok => ({
	...item,
	link:
		item.link?.cached_url ||
		localePath(
			`/category/${createCategoryLink({ category: { CategoryId: Number(item.id) } })}`
		)
});

const toCategoryWithFiles = (item) =>
	({
		Id: Number(item.id),
		CategoryId: Number(item.id),
		Name: item.name,
		Files: [{ ImagePath: item.image?.filename }]
	}) as CategoryWithFiles;

items.value =
	blok?.items?.map((item) =>
		blok.is_carousel ? toCategoryWithFiles(item) : toCategoryHeroBlok(item)
	) || [];
</script>
